import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className, ariaLabel, isCurrent = false, children }) {
    return (
        <a
            class={`pagination__item ${isCurrent ? "pagination__item--current light" : "link"} ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination({className, paginationWidth}) {
    // const paginationWidth = window.innerWidth <= 1024 ? 3 : 5;
    const { prev, first, pages, last, next } = usePagination({
        width: paginationWidth
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <div className={`pagination-wrapper ${className}`}>
            <nav className="pagination" role="navigation" aria-label="Pagination">
                <ul class="pagination__list list-unstyled">
                    {prev && (
                        <li>
                            <PageLink {...pageLinkProps(prev)} className="ns-previous" ariaLabel="Previous page">
                                <Icon name="arrow" className="ns-page-prev-icon" />
                            </PageLink>
                        </li>
                    )}

                    {first && (
                        <>
                            <li>
                                <PageLink 
                                    isCurrent={!!first?.current}
                                    {...pageLinkProps(first)} ariaLabel="First page">
                                        {first.page}
                                </PageLink>
                            </li>
                            <li><span class="pagination__item">...</span></li>
                        </>
                    )}

                    {pages.map(page => (
                        <li key={page.page}>
                            <PageLink 
                                isCurrent={!!page?.current}
                                ariaLabel={`${page.page} page`} 
                                {...pageLinkProps(page)}>
                                    {page.page}
                            </PageLink>
                        </li>
                    ))}

                    {last && (
                        <>
                            <li><span class="pagination__item">...</span></li>
                            <li>
                                <PageLink 
                                    isCurrent={!!last?.current}
                                    {...pageLinkProps(last)} ariaLabel="Last page">
                                        {last.page}
                                    </PageLink>
                            </li>
                        </>
                    )}

                    {next && (
                        <li>
                            <PageLink {...pageLinkProps(next)} className="ns-next" ariaLabel="Next page">
                                <Icon name="arrow" className="ns-page-next-icon" />
                            </PageLink>
                        </li>
                    )}
                </ul>
            </nav>
        </div>
    )
}
